import gql from "graphql-tag";

export const VALUE_LIST_FRAGMENT = gql`
    fragment valueListFragment on ValueListLight {
        id
        type
        code
        label
        label2
    }
`;

export const VALUE_LIST_TYPES = gql`
    query ValueListTypes {
        valueListTypes {
            id
            type
        }
    }`


export const VALUE_LIST = gql`
    query ValueList {
        valueList {
            id
            type
            code
            label
            label2
            parentId
            lang
            parentValueList{
                id
                code
            }
        }

    }`
export const ORG_VALUE_LISTS = gql`
    ${VALUE_LIST_FRAGMENT}
    query OrgValueLists {
        orgValueLists {
            orgPrefixes {
                ...valueListFragment
            }
            orgUnitDesignators {
                ...valueListFragment
            }
            orgCategoryTypes {
                ...valueListFragment
            }
            orgOfficeLanguages {
                ...valueListFragment
            }
            orgOpeningTimes {
                ...valueListFragment
            }
            orgClosingTimes {
                ...valueListFragment
            }
            otherOrgOrgRelTypes {
                ...valueListFragment
            }
            posHonorifics {
                ...valueListFragment
            }
            phoneTypes {
                ...valueListFragment
            }
            posPhoneTypes {
                ...valueListFragment
            }
            digitalTypes {
                ...valueListFragment
            }
            posStatusReason{
                ...valueListFragment
            }
            indAssignmentTypes{
                ...valueListFragment
            }
            roleIndAssignmentTypes{
                ...valueListFragment
            }
            genderTypes{
                ...valueListFragment
            }
            honorificTitles{
                ...valueListFragment
            }
            orgPosRelTypes{
                ...valueListFragment
            }
            orgRoleRelTypes{
                ...valueListFragment
            },
            announcement,
            posSeparators{
                ...valueListFragment
            },
            frCategory{
                ...valueListFragment
            },
            streetTypeCodes{
               ...valueListFragment
            },
            orgTypes {
                id
                type
                code
                label
                parentId
                levelNum
                displayOrder
            }
            topOrgTypeMap @client
            orgTypeMap @client
        }
    }
`;

const VALUE_INFO_FRAGMENT = gql`
  fragment valueInfoFragment on ValueInfo {
    id: valueId
    type
    code
    label: fromLabel
    label2: toLabel
    lang: language
    level
    metadata: metaData
    abbr: abrvn
    comment
    desc
    active
    displayOrder
    ts: createTimestamp
    parent {
      id: valueId
      type
      code
    }
  }
`;

export const GET_VALUE_LIST_BY_TYPE = gql`
  ${VALUE_INFO_FRAGMENT}
  query GetValueListByType($type:String!) {
    getValueListByType(type:$type) {
      ...valueInfoFragment
    }
  }
`;

export const CREATE_VALUE_INFO = gql`
  ${VALUE_INFO_FRAGMENT}
  mutation CreateValueInfo($input: ValueInfoInput!) {
    createValueInfo(input: $input) {
      ...valueInfoFragment
    }
  }
`;

export const UPDATE_VALUE_INFO = gql`
  ${VALUE_INFO_FRAGMENT}
  mutation UpdateValueInfo($id: ID!, $input: ValueInfoInput!) {
    updateValueInfo(id: $id, input: $input) {
      ...valueInfoFragment
    }
  }
`;

export const UPDATE_VALUE_ORDERS = gql`
  mutation UpdateValueOrders($inputs: [ValueOrderInput!]!) {
    updateValueOrders(inputs: $inputs)
  }
`;

export const GET_VALUE_LIST_TYPES = gql`
  query GetValueListTypes {
    valueListTypes
  }
`;

export const GET_ADMIN_QUERIES = gql`
    query GetAdminQueries {
        getAdminQueries{
            id
            label
            displayOrder
            parameters  {
                name
                type
                maxLength
                defaultValue
            }
        }
    }
`;

